// import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { register, reset } from '../../../Redux/Features/Auth/authSlice';
// import { CUSTOMERS_API } from '../../../Utilities/APIs';
// import Logo from '../../Partials/Elements/Logo/Logo';
import Form from '../../Partials/Layouts/Forms/Form';
import EmailInput from '../../Partials/Layouts/Forms/FormInputs/EmailInput/EmailInput';
import PasswordInput from '../../Partials/Layouts/Forms/FormInputs/PasswordInput/PasswordInput';
import ShortTextInput from '../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput';
import FormSubmitButton from '../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton';

import './Auth.css';

function SignUp() {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [language, setLanguage] = useState('default')

    const { isLoading, customer, isError, isSuccess, message } = useSelector((state) => state.auth)


    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        if (isError) {
            console.log(message)
        }
        if (isSuccess && customer && !customer.isVerified) {
            navigate('/verify-email')
        }
        dispatch(reset())
    })


    async function handleSubmit(e) {

        e.preventDefault();

        if (password !== password2) {
            console.log('Passwords do not match!')

        } else {

            const customerData = {};

            customerData.name = name;
            customerData.email = email;
            customerData.language = language;
            customerData.password = password;

            dispatch(register(customerData))
            navigate('/verify-email/default')


        }

    }


    if (isLoading) {
        return <h1>Loading...</h1>
    }

    return (
        <section className=" auth_page page_padding">
            <div className="container">
                {/* <div className="page_logo">
                    <Logo />
                </div> */}
                <div className="centered_form_wrapper">
                    <div className="form_wrapper">
                        <h3>Sign Up</h3>
                        <Form
                            onSubmit={handleSubmit}
                        >
                            <ShortTextInput
                                label='Name'
                                value={name}
                                placeholder='Please Enter your Name'
                                setState={setName}
                            />
                            <EmailInput
                                label={'Email'}
                                inputName={email}
                                placeholder={'Please enter your Email'}
                                setState={setEmail}
                            />
                            <PasswordInput
                                label='Password'
                                value={password}
                                placeholder='Please Enter your Password'
                                setState={setPassword}
                            />
                            <PasswordInput
                                label='Confirm Password'
                                value={password2}
                                placeholder='Please Confirm your Password'
                                setState={setPassword2}
                            />
                            <div className="input_group">
                                <label className="input_field_label">Language</label>
                                <select className='select_field' value={language} onChange={e => setLanguage(e.target.value)}>
                                    <option value='default' hidden>Select Language</option>
                                    <option value='bangla'>Bangla</option>
                                    <option value='english'>English</option>
                                </select>
                            </div>

                            <FormSubmitButton text='create your account' />

                        </Form>

                        <div className="dha_box">
                            <p className="body_text">Already have an account?</p>
                            <Link to='/login' className='btn_text sign_up'>log in</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SignUp